import React, { useState, useEffect } from 'react';

import { Box } from 'ui/box';

interface ImageComponentProps {
  src?: string;
  height: number;
  width: number;
  alt?: string;
}

const ImageComponent = ({
  src = '',
  height,
  width,
  alt = '',
}: ImageComponentProps): React.JSX.Element => {
  const [maxWidth, setMaxWidth] = useState<number>(780);

  const aspectRatio = height / width;
  const newHeight = aspectRatio * maxWidth;

  const breakpoints = {
    mobile: 335,
    tablet: 780,
    xs: 880,
    md: 780,
  };

  useEffect(() => {
    function handleResize(): void {
      if (window.innerWidth < breakpoints.tablet) {
        setMaxWidth(breakpoints.mobile);
      } else if (window.innerWidth < breakpoints.xs) {
        setMaxWidth(breakpoints.tablet);
      } else if (window.innerWidth < breakpoints.md) {
        setMaxWidth(breakpoints.xs);
      } else {
        setMaxWidth(breakpoints.md);
      }
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Box
      sx={{
        '@media (min-width: 375px)': { mb: 3 },
        '@media (min-width: 960px)': { mb: 4 },
      }}
    >
      <img
        src={src}
        alt={alt}
        className="flex"
        style={{ minHeight: newHeight, height: newHeight }}
      />
    </Box>
  );
};

export default ImageComponent;
